export default __webpack_public_path__ + "static/media/rotation_puzzle.5b3a63a3.png";